{
	"actions": {
		"save": "Сохранить",
		"cancel": "Отмена",
		"delete": "Удалить",
		"edit": "Изменить",
		"create": "Создать",
		"confirm": "Подтвердить",
		"back": "Назад",
		"next": "Далее",
		"done": "Готово",
		"close": "Закрыть",
		"open": "Открыть",
		"retry": "Повторить",
		"copy": "Копировать",
		"share": "Поделиться",
		"download": "Скачать",
		"upload": "Загрузить",
		"search": "Поиск",
		"filter": "Фильтр",
		"sort": "Сортировка",
		"select": "Выбрать",
		"selectAll": "Выбрать всё",
		"clearAll": "Очистить",
		"apply": "Применить",
		"reset": "Сбросить",
		"more": "Ещё",
		"showMore": "Показать больше",
		"showLess": "Скрыть",
		"expand": "Развернуть",
		"collapse": "Свернуть",
		"viewAll": "Все",
		"menu": "Меню действий"
	},
	"state": {
		"loading": "Загрузка…",
		"saving": "Сохранение…",
		"processing": "Обработка…",
		"empty": "Пусто",
		"error": "Ошибка",
		"success": "Готово",
		"noResults": "Ничего не найдено",
		"comingSoon": "Скоро",
		"loadingApp": "Загрузка приложения…"
	},
	"yesNo": {
		"yes": "Да",
		"no": "Нет"
	},
	"confirm": {
		"trashTitle": "Переместить «{name}» в корзину?",
		"trashTitleGeneric": "Переместить материал в корзину?",
		"trashDescription": "Можно восстановить из корзины в течение 30 дней.",
		"deleteTitle": "Удалить «{name}»?",
		"deleteTitleGeneric": "Удалить элемент?",
		"deleteDescription": "Это действие нельзя отменить.",
		"moveToTrash": "В корзину"
	},
	"time": {
		"now": "сейчас",
		"today": "сегодня",
		"yesterday": "вчера",
		"tomorrow": "завтра",
		"thisWeek": "на этой неделе",
		"older": "раньше",
		"minutesAgo": "{count, plural, one {# минуту назад} few {# минуты назад} many {# минут назад} other {# минуты назад}}",
		"hoursAgo": "{count, plural, one {# час назад} few {# часа назад} many {# часов назад} other {# часа назад}}",
		"daysAgo": "{count, plural, one {# день назад} few {# дня назад} many {# дней назад} other {# дня назад}}"
	},
	"units": {
		"items": "{count, plural, =0 {Нет элементов} one {# элемент} few {# элемента} many {# элементов} other {# элемента}}",
		"minutes": "{count, plural, one {# минута} few {# минуты} many {# минут} other {# минуты}}",
		"seconds": "{count, plural, one {# секунда} few {# секунды} many {# секунд} other {# секунды}}",
		"bytes": "{count} Б",
		"kilobytes": "{count} КБ",
		"megabytes": "{count} МБ"
	},
	"offline": {
		"banner": "Нет соединения · работаем в офлайн-режиме",
		"bannerWithQueue": "Офлайн · {count, plural, one {# действие} few {# действия} many {# действий} other {# действия}} в очереди",
		"writeBlocked": "Требуется подключение к интернету",
		"queued": "Очередь на отправку",
		"sendFailed": "Ошибка отправки — нажмите, чтобы повторить",
		"waitingForNetwork": "Ожидание подключения…",
		"autoRetry": "Переподключение…",
		"syncingLibrary": "Синхронизация библиотеки…",
		"mediaUnavailable": "Изображение недоступно офлайн",
		"mediaUnavailableHint": "Подключитесь к сети, чтобы загрузить медиа",
		"changesDropped": "{count, plural, one {# изменение} few {# изменения} many {# изменений} other {# изменений}} не удалось сохранить на сервере, данные были отброшены",
		"noCachedCopy": "Материал недоступен в офлайн-режиме",
		"noCachedCopyHint": "Файл еще не загружен на это устройство. Подключитесь к сети, чтобы открыть его.",
		"syncConnecting": "Подключение к синхронизации…",
		"syncDownloading": "Загрузка библиотеки…",
		"syncDownloadingPercent": "Загрузка библиотеки… {percent}% ({downloaded}/{total})",
		"syncDownloadingPending": "Загрузка библиотеки… {count, plural, one {# элемент в очереди} few {# элемента в очереди} many {# элементов в очереди} other {# элемента в очереди}}",
		"syncError": "Ошибка синхронизации — проверьте соединение",
		"syncIssuesAction": "Просмотреть проблемы синхронизации",
		"changesDroppedWithCenter": "{count, plural, one {# изменение} few {# изменения} many {# изменений} other {# изменения}} не удалось сохранить — проверьте в центре синхронизации",
		"syncInitializing": "Подготовка библиотеки…",
		"syncFirstRunHint": "Первая загрузка после обновления — это может занять до минуты"
	},
	"quota": {
		"remaining": "осталось"
	},
	"appUpdate": {
		"available": "Доступна новая версия",
		"action": "Обновить",
		"forced": "Обновляем приложение…"
	},
	"view": {
		"label": "Вид отображения",
		"grid": "Карточки",
		"list": "Список"
	},
	"regenerate": {
		"confirmTitle": "Перегенерировать?",
		"confirmAction": "Перегенерировать",
		"note": "Текущий конспект будет заменён новой версией. Прошлая сохранится в истории версий.",
		"material": "Конспект, карточки, тест и глоссарий по этому материалу будут сгенерированы заново и заменят текущие. Это затратная AI-операция — расходует сразу несколько генераций из квоты.",
		"audio": "Текущее аудио-резюме будет заменено новой версией.",
		"collection": "Текущий артефакт для всей папки будет заменен новой версией."
	},
	"status": {
		"queued": "В очереди",
		"processing": "Обработка",
		"ready": "Готово",
		"partial": "Частично",
		"error": "Ошибка",
		"trial": "Пробный период",
		"pro": "Pro",
		"plus": "Plus",
		"free": "Free"
	},
	"pagination": {
		"previous": "Назад",
		"next": "Вперёд",
		"morePages": "Ещё страницы",
		"label": "Страницы",
		"page": "Страница {page}"
	},
	"errors": {
		"404": {
			"title": "Страница не найдена",
			"description": "Страницы, которую вы ищете, не существует или она была перемещена.",
			"backToHome": "На главную"
		},
		"generic": "Что-то пошло не так. Попробуйте ещё раз.",
		"boundary": {
			"title": "Что-то пошло не так",
			"body": "Произошла непредвиденная ошибка. Мы уже знаем о ней. Попробуйте перезагрузить страницу.",
			"reload": "Перезагрузить",
			"retry": "Попробовать снова"
		},
		"notFound": {
			"title": "Страница не найдена",
			"description": "Возможно, ссылка устарела или страница была удалена.",
			"home": "На главную"
		},
		"server": {
			"title": "Сервер недоступен",
			"description": "Попробуйте обновить страницу через несколько секунд.",
			"retry": "Попробовать снова"
		},
		"chunkLoad": {
			"title": "Не удалось загрузить экран",
			"bodyOffline": "Этот раздел пока недоступен офлайн. Мы повторим попытку при восстановлении сети.",
			"bodyOnline": "Не удалось загрузить модуль страницы. Попробуйте ещё раз.",
			"retry": "Попробовать снова"
		}
	},
	"player": {
		"play": "Воспроизвести",
		"pause": "Пауза",
		"rate": "Скорость воспроизведения",
		"close": "Закрыть плеер"
	},
	"upgrade": {
		"title": "Откройте Plus",
		"description": "Безлимит AI, голосовой репетитор, расширенные тесты.",
		"cta": "Узнать больше"
	},
	"combobox": {
		"placeholder": "Выбрать…",
		"search": "Поиск…",
		"empty": "Ничего не найдено"
	},
	"magicMoment": {
		"title": "Создаём твой материал…",
		"cancel": "Отменить"
	},
	"streakCard": {
		"day": "день подряд",
		"days": "дней подряд"
	},
	"citation": {
		"page": " · стр. {page}"
	},
	"shell": {
		"expandSidebar": "Развернуть боковую панель",
		"collapseSidebar": "Свернуть боковую панель"
	},
	"materialCard": {
		"favorite": "В избранное",
		"unfavorite": "Убрать из избранного",
		"menu": "Меню"
	},
	"rating": {
		"again": "Снова",
		"hard": "Сложно",
		"good": "Хорошо",
		"easy": "Легко"
	},
	"dataTable": {
		"empty": "Нет данных"
	},
	"actionBar": {
		"label": "Панель действия"
	},
	"wizard": {
		"stepsLabel": "Шаги",
		"goToStep": "Вернуться к шагу «{label}»"
	},
	"price": {
		"free": "Бесплатно"
	},
	"generation": {
		"progress": "{percent}%",
		"etaApprox": "~",
		"etaSeconds": "{prefix}{count}с",
		"etaMinutes": "{prefix}{count} мин.",
		"partialCoverageTitle": "Частичный охват источника",
		"partialCoverageBody": "Исходный материал слишком велик — результат сгенерирован на основе его части. Разделите материал или сузьте область охвата, чтобы включить всё."
	},
	"sync": {
		"pendingBanner": "Не синхронизировано: {count, plural, one {# действие} few {# действия} many {# действий} other {# действия}} — отправляем",
		"localDbLost": {
			"message": "Браузер потерял доступ к данным на устройстве. Перезагрузите страницу, чтобы продолжить.",
			"action": "Перезагрузить"
		}
	},
	"whatIsThis": "Что это?",
	"sectionIntro": {
		"dismiss": "Понятно",
		"reopen": "Что это за раздел"
	},
	"method": {
		"step1": {
			"ordinal": "1",
			"label": "Разобраться"
		},
		"step2": {
			"ordinal": "2",
			"label": "Проверить"
		},
		"step3": {
			"ordinal": "3",
			"label": "Добрать"
		}
	},
	"account": {
		"points": "Баллы",
		"pointsApproximate": "Баланс может быть неактуален",
		"iecPlusHint": "Ваш уровень во всей экосистеме"
	}
}
